import React, { useEffect, useState } from "react";
import { Sparkle, Menu, X } from "lucide-react";

const links = [
  { href: "#services", label: "Services" },
  { href: "#process", label: "Process" },
  { href: "#about", label: "About" },
  { href: "#media-network", label: "Media" },
  { href: "#faq", label: "FAQ" },
  { href: "#contact", label: "Contact" },
];

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-nav"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "backdrop-blur-xl bg-black/70 border-b border-white/5"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-12 h-16 md:h-20 flex items-center justify-between">
        <a
          href="#top"
          data-testid="nav-logo"
          className="flex items-center group"
        >
          <img
            src="/assets/nova-logo.png"
            alt="NOVA MEDIA — PR Influencers Partnerships"
            className="h-7 md:h-9 w-auto transition-transform duration-700 group-hover:scale-[1.03] select-none"
            draggable={false}
          />
        </a>

        <nav className="hidden lg:flex items-center gap-8 xl:gap-10">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="text-[11px] uppercase tracking-[0.28em] text-white/70 hover:text-[#7FB3D5] transition-colors duration-300 relative group whitespace-nowrap"
            >
              {l.label}
              <span className="absolute left-0 -bottom-1 w-0 h-px bg-[#7FB3D5] transition-all duration-500 group-hover:w-full" />
            </a>
          ))}
        </nav>

        <a
          href="#contact"
          data-testid="nav-cta-button"
          className="hidden lg:inline-flex items-center gap-2 px-5 py-2.5 border border-[#7FB3D5] text-[11px] uppercase tracking-[0.25em] text-white hover:bg-[#7FB3D5] hover:text-black transition-all duration-300 whitespace-nowrap"
        >
          Book a call
          <Sparkle className="w-3 h-3" strokeWidth={1.2} />
        </a>

        <button
          aria-label="Open menu"
          data-testid="nav-mobile-toggle"
          className="lg:hidden text-white p-2"
          onClick={() => setOpen(!open)}
        >
          {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
        </button>
      </div>

      {open && (
        <div
          data-testid="nav-mobile-menu"
          className="lg:hidden bg-black/95 backdrop-blur-xl border-t border-white/5"
        >
          <div className="flex flex-col gap-6 px-6 py-8">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="text-sm uppercase tracking-[0.28em] text-white/80 hover:text-[#7FB3D5]"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#contact"
              onClick={() => setOpen(false)}
              className="mt-2 inline-flex items-center justify-center gap-2 px-5 py-3 border border-[#7FB3D5] text-xs uppercase tracking-[0.25em] text-white"
            >
              Book a call <Sparkle className="w-3 h-3" />
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
